export interface UserResponse {
  email: string;
  firstName: string;
  lastName: string;

  tfaAuthenticated: boolean;
}

export class User {
  email: string;
  firstName: string;
  lastName: string;
  tfaAuthenticated: boolean;

  // Computed Fields
  fullName: string;

  constructor({ email, firstName, lastName, tfaAuthenticated }: UserResponse) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.tfaAuthenticated = tfaAuthenticated;

    this.fullName = `${this.firstName} ${this.lastName}`.trim();
  }
}

export interface Token {
  access: string;
  refresh: string;
}

export interface UserQuery {
  userSelf: User;
}
